<div class="content-loaf">
  <h2>空床情報更新</h2>
  <hr />

  <div class="row content-block" *ngIf="institutionInfo.institutionId != null">
    <div class="col-12">
      <div>
        <!-- パソコン用表示 -->
        <div class="content-block d-none d-lg-block">
          <table class="table table-default edit-table table-bordered">
            <thead>
              <tr>
                <th style="min-width: 200px;">施設名</th>
                <th style="min-width: 110px;">病棟</th>
                <th style="min-width: 80px;">男 (床)</th>
                <th style="min-width: 80px;">女 (床)</th>
                <th>備考</th>
                <th style="min-width: 120px;">更新日時</th>
              </tr>
            </thead>

            <tbody name="institution">
              <tr name="ward" *ngIf="institutionInfo.wards.length > 0">
                <td class="vertical-middle" [attr.rowspan]="institutionInfo.wards.length">
                  <h5 name="institutionName">{{institutionInfo.institutionName}}</h5>
                  <p>
                    <span name="tel">電話：{{institutionInfo.tel}}</span><br />
                    <span name="fax">FAX ：{{institutionInfo.fax}}</span><br />
                    <span name="address">住所：{{institutionInfo.address}}</span>
                  </p>
                  <textarea name="comment" rows="5" [(ngModel)]="institutionInfo.comment" (ngModelChange)="clearMessage()"></textarea>
                </td>
                <!-- 1つ目の病棟はべた書き -->
                <td name="ward-name" class="vertical-middle">{{institutionInfo.wards[0].name}}</td>
                <td class="text-center vertical-middle">
                  <app-vacant-bed-select name="male-count" [(count)]="institutionInfo.wards[0].maleCount"></app-vacant-bed-select>
                </td>
                <td class="text-center vertical-middle">
                  <app-vacant-bed-select name="female-count" [(count)]="institutionInfo.wards[0].femaleCount"></app-vacant-bed-select>
                </td>
                <td class="vertical-middle">
                  <textarea name="ward-comment" rows="5" [(ngModel)]="institutionInfo.wards[0].comment" (ngModelChange)="clearMessage()"></textarea>
                </td>

                <td class="text-center vertical-middle" [attr.rowspan]="institutionInfo.wards.length">
                  <span name="update-date">{{institutionInfo.updateTime | date: 'yyyy/MM/dd'}}</span><br />
                  <span name="update-time">{{institutionInfo.updateTime | date: 'HH:mm'}}</span>
                </td>
              </tr>

              <!-- 2つ目以降の病棟をngForで回す -->
              <tr name="ward" *ngFor="let ward of institutionInfo.wards.slice(1)">
                <td name="ward-name" class="vertical-middle">{{ward.name}}</td>
                <td class="text-center vertical-middle">
                  <app-vacant-bed-select name="male-count" [(count)]="ward.maleCount"></app-vacant-bed-select>
                </td>
                <td class="text-center vertical-middle">
                  <app-vacant-bed-select name="female-count" [(count)]="ward.femaleCount"></app-vacant-bed-select>
                </td>
                <td class="vertical-middle">
                  <textarea name="ward-comment" rows="5" [(ngModel)]="ward.comment" (ngModelChange)="clearMessage()"></textarea>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- スマホ用表示 -->
        <div class="content-block d-lg-none">
          <div class="row institution-content" *ngIf="institutionInfo.wards.length > 0">
            <div class="col-12 col-sm-6">
              <h4>{{institutionInfo.institutionName}}</h4>
            </div>

            <div class="col-12 col-sm-6 text-right">
              更新日時 : {{institutionInfo.updateTime | date: 'yyyy/MM/dd HH:mm'}}
            </div>

            <div class="col-12 institution-separator">
              <hr />
            </div>

            <div class="col-12 institution-remarks">
              <p>
                電話：{{institutionInfo.tel}}<br />
                FAX ：{{institutionInfo.fax}}<br />
                住所：{{institutionInfo.address}}<br />

                <textarea name="comment" rows="5" [(ngModel)]="institutionInfo.comment" (ngModelChange)="clearMessage()"></textarea>
              </p>
            </div>

            <div class="col-12" *ngFor="let ward of institutionInfo.wards">
              <table class="table table-default reference-table table-bordered">
                <thead>
                  <tr>
                    <th colspan="2" class="text-center">{{ward.name}}</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td class="text-center" style="width: 80px;">男 (床)</td>
                    <td class="text-center">
                      <app-vacant-bed-select [(count)]="ward.maleCount"></app-vacant-bed-select>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center">女 (床)</td>
                    <td class="text-center">
                      <app-vacant-bed-select [(count)]="ward.femaleCount"></app-vacant-bed-select>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center vertical-middle">備考</td>
                    <td>
                      <textarea rows="5" [(ngModel)]="ward.comment" (ngModelChange)="clearMessage()"></textarea>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="text-right">
    <i *ngIf="isUpdating" class='fa fa-circle-o-notch fa-spin'></i>
    <button name="update" type="button" class="btn btn-primary btn-primary-gradient" [disabled]="isUpdating" (click)="update()">更新</button>
  </div>
</div>
